<template>
  <div style="clear: both">
    <v-card :color="bgColor">
      <v-toolbar elevation="1" density="compact" :title="displayTitle">
        <v-spacer></v-spacer>
        <v-tooltip :text="$t('Add_Bulk_Users')" location="bottom" v-if="bulkUserAdd">
          <template v-slot:activator="{ props }">
            <div v-if="bulkUserSaving === true" v-bind="props">
              <v-progress-circular indeterminate></v-progress-circular>
            </div>
            <v-btn
              v-if="bulkUserSaving === false"
              v-bind="props"
              @click="addBulkUsersShow = true"
              icon="mdi-account-multiple-plus-outline"
            >
              </v-btn>
          </template>
        </v-tooltip>
      </v-toolbar>
      <div>
        <!-- search -->
        <template v-if="!readonly">
          <div style="display: flex">
            <div style="flex: 1">
              <template v-if="!isExternal">
                <v-card-text>
                  <v-autocomplete
                    @blur="emitBlur"
                    v-model="user"
                    :items="displayUsers"                    
                    :loading="isLoading"
                    v-model:search="userSearch"
                    hide-no-data
                    hide-selected
                    variant="underlined"
                    item-title="displayName"
                    item-value="id"
                    :append-icon="user != null ? 'mdi-information-outline' : undefined"
                    @click:append="showHideVCard"
                    @click:clear="clear"
                    :placeholder="$t('Prompt_TypeToSearch')"
                    return-object
                    clearable
                    :error-messages="errorMessages"
                  >
                    <template v-slot:item="{ props, item }">
                      <v-list-item v-bind="props" :title="item.raw.displayName">
                        <template v-if="!item.raw.generatedItem">
                          <v-list-item-subtitle
                            >{{ item.raw.jobTitle }}- {{ item.raw.userPrincipalName.split('@')[0] }}</v-list-item-subtitle
                          >
                        </template>
                      </v-list-item>
                    </template>
                  </v-autocomplete>
                </v-card-text>
              </template>
              <template v-else>
                <v-text-field
                  v-model.trim="externalUser"
                  clearable
                  variant="underlined"
                  :placeholder="$t('Prompt_External_Email')"
                  :rules="externalEmailRules"
                  validate-on-blur
                >
                  <template v-slot:append>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn icon @click="addExternalUser()" :disabled="isAddExternalDisabled">
                          <v-icon v-on="on">add_circle_outline</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t('Add') }}</span>
                    </v-tooltip>
                  </template>
                </v-text-field>
              </template>
            </div>
            <template v-if="showExternalSelection">
              <v-tooltip bottom>
                <template v-slot:activator="{ props }">
                  <v-checkbox
                    class="ml-2 centered-checkbox"
                    v-bind="props"
                    v-model="isExternal"
                    label
                    :readonly="readonly"
                  ></v-checkbox>
                </template>
                <span>{{ $t('Add_Third_Party_User') }}</span>
              </v-tooltip>
            </template>
          </div>
        </template>

        <v-expand-transition v-if="showVCard">
          <user-details :user="user"></user-details>
        </v-expand-transition>
        <!-- end search -->
        <v-list>
        <v-list-group v-for="selectedUser in displaySelectedUsers" :key="selectedUser.id" v-model="selectedUser.active" >
          <template v-slot:activator="{ props }">
            <v-list-item v-bind="props" @click="selectedUser.isExpand = !selectedUser.isExpand">
              <div v-if="selectedUser != null">
                <v-list-item-title>{{ selectedUser.displayName }}</v-list-item-title>
                <v-list-item-subtitle class="job-title">{{ selectedUser.jobTitle }}</v-list-item-subtitle>
              </div>
              <template v-slot:append>
                <v-list-item-action>
                  <v-checkbox
                    class="cbox-approver"
                    @click.stop
                    v-if="showRequired"
                    v-model="selectedUser.required"
                    :label="$t('Mandatory_Approver')"
                    :readonly="showRequiredReadOnly"
                  ></v-checkbox>
                </v-list-item-action>
                <v-list-item-action v-if="selectedUser.readonly ? false : !readonly">
                  <v-btn color="grey-lighten-1" icon="mdi-delete-outline" variant="text" @click.stop="removeSelectedUser(selectedUser)">
                  </v-btn>              
                </v-list-item-action>
                <v-list-item-action>                  
                  <v-btn :icon="selectedUser.isExpand ? 'mdi-chevron-up' : 'mdi-chevron-down'" variant="text"></v-btn>
                </v-list-item-action>
              </template>
            </v-list-item>
          </template>
          <v-list-item>
            <user-details @closeDetails="selectedUser.active = false" :user="selectedUser" :showCloseBtn="false"></user-details>
          </v-list-item>
        </v-list-group>
        </v-list>
      </div>
    </v-card>

    <template v-if="addBulkUsersShow">
      <Add-Bulk-Users
        v-if="addBulkUsersShow"
        @bulkUsers="addBulkUser($event)"
        :currentUsers="selectedUsers"
        @close="addBulkUsersShow = false"
      ></Add-Bulk-Users>
    </template>

    <template v-if="errorBulkUsersShow">
      <v-dialog v-model="errorBulkUsersShow" persistent max-width="400">
        <v-card>
          <v-app-bar color="error" dense>
            <v-spacer></v-spacer>
            <v-icon>mdi-bell-alert-outline</v-icon>
          </v-app-bar>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-card-text>
                  The following users could not be added.
                  <v-textarea readonly solo v-model="errorBulkUsers" />
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="errorBulkUsersShow = false">{{ $t('OK') }}</v-btn>
                </v-card-actions>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
    </template>
  </div>
</template>

<script>
import axios from 'axios'
import UserDetails from '@/components/peoplePicker/UserDetails'
import AdminService from '@/services/admin.service'
import { debounce } from '@/common'
import { PeoplePickerActions } from '@/common/peoplePickerActions'
import AddBulkUsers from '@/components/peoplePicker/AddBulkUsers'
export default {
  emits: ['blur', 'clear', 'update:model-value', 'update', 'beforeDelete'],
  data() {
    return {
      isLoading: false,
      loginFailed: null,
      selectedUsers: this.modelValue,
      showIcon: false,
      showVCard: false,
      showVCardId: null,
      user: null,
      userImageSrc: null,
      userPhoto: '',
      users: [],
      userSearch: '',
      cancelSource: [],
      isExternal: false,
      externalUser: '',
      externalEmailRules: [
        (v) => (v && v.trim() ? true : this.$t('Required')),
        // eslint-disable-next-line no-useless-escape
        (v) => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || this.$t('Invalid_Email_Error')
      ],
      trigger: 'loading',
      addBulkUsersShow: false,
      errorBulkUsersShow: false,
      errorBulkUsers: [],
      bulkUserSaving: false
    }
  },
  props: {
    title: {
      type: String,
      default: null
    },
    readonly: {
      type: Boolean,
      default: false
    },
    showRequired: {
      type: Boolean,
      default: false
    },
    showRequiredReadOnly: {
      type: Boolean,
      default: false
    },
    showCounter: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: null
    },
    confidentialOptions: {
      type: Object,
      default: undefined
    },
    showExternalSelection: {
      type: Boolean,
      default: false
    },
    modelValue: {
      type: Array
    },
    errorMessages: {
      type: String
    },
    bulkUserAdd: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    emitBlur() {
      this.$emit('blur')
    },
    addBulkUser: async function (usersIn) {
      if (!this.bulkUserSaving) {
        this.bulkUserSaving = true
        let results = null
        let promises = []
        let source = axios.CancelToken.source()
        this.cancelSource.push(source)

        for (let i = 0; i < usersIn.length; i++) {
          promises.push(
            AdminService.getUsersByUserPrincipalName(
              source.token,
              this.confidentialOptionsComputed.confidentialCommunityAbbreviation,
              usersIn[i]
            )
              .then((result) => {
                if (result.length > 0) {
                  return result[0]
                }
                return { error: 'true', errorUser: usersIn[i] }
              })
              .catch(() => {})
          )
        }
        results = await Promise.all(promises)

        let errors = results.filter((r) => typeof r !== 'undefined' && r.error)
        if (errors.length > 0) {
          this.errorBulkUsers = [...errors.map((c) => c.errorUser)].join('\n')
          this.errorBulkUsersShow = true
        }

        // we need to filter out an undefined user or it will bomb later in the process.
        let result = results.filter((r) => typeof r !== 'undefined' && !r.error)

        const tempUsers = result.concat(this.selectedUsers)
        const uniqueUsers = this.$_.uniqBy(tempUsers, 'id')
        this.selectedUsers = this.$_.sortBy(uniqueUsers, 'displayName')

        this.$emit('update', { Users: this.selectedUsers, Action: PeoplePickerActions.properties[PeoplePickerActions.ADD].value })
        this.bulkUserSaving = false
      }
    },
    getUsers(query) {
      this.cancelGetUsers()
      let source = axios.CancelToken.source()
      this.cancelSource.push(source)

      AdminService.getUsersForPeoplePicker(
        source.token,
        this.confidentialOptionsComputed.confidentialCommunityAbbreviation,
        query,
        this.includeInactiveUsers,
        this.includeDistroService
      )
        .then((result) => {
          this.cancelSource = []
          this.users = result
        })
        .catch(() => {})
    },
    cancelGetUsers() {
      if (this.cancelSource) {
        this.cancelSource.forEach((ct) => {
          ct.cancel('Start new search, stop active search')
        })
      }
    },
    showHideVCard() {
      this.showVCard = !this.showVCard
    },
    clear() {
      this.users = []
      this.user = null
      this.$emit('clear')
    },
    removeSelectedUser(removedUser) {
      this.trigger = 'delete'
      if (this.$attrs.onBeforeDelete) {
        this.$emit('beforeDelete', removedUser, this.selectedUsers, () => {
          this.selectedUsers = this.$_.filter(this.selectedUsers, (user) => user.id !== removedUser.id)
          this.$emit('update', {
            Users: this.selectedUsers,
            Action: PeoplePickerActions.properties[PeoplePickerActions.DELETE].value
          })
        })
      } else {
        this.selectedUsers = this.$_.filter(this.selectedUsers, (user) => user.id !== removedUser.id)
        this.$emit('update', {
          Users: this.selectedUsers,
          Action: PeoplePickerActions.properties[PeoplePickerActions.DELETE].value
        })
      }
    },
    showHideVCardById(id) {
      this.showVCardId = id
    },
    addExternalUser() {
      if (this.externalUser && this.externalUser.trim()) {
        this.selectedUsers.push({
          id: this.externalUser,
          displayName: this.externalUser,
          mail: this.externalUser,
          isExternal: true
        })
        const tempUsers = this.$_.clone(this.selectedUsers)
        this.selectedUsers = this.$_.uniqBy(tempUsers, 'id')
        this.$emit('update:model-value', this.selectedUsers)
      }

      this.externalUser = ''
      this.isExternal = false
    }
  },
  watch: {
    modelValue: function (newValue) {
      console.log(`people picker ms.vue watch modelValue`)
      this.selectedUsers = this.modelValue
      this.$emit('update:model-value', newValue)
    },
    selectedUsers: function (newValue) {
      if (this.trigger === 'add') {
        this.$emit('update', { Users: newValue, Action: PeoplePickerActions.properties[PeoplePickerActions.ADD].value })
      }
      this.trigger = null
    },
    userSearch: debounce(function (q) {
      this.showVCard = false

      //if current user is same as the query then don't do the search
      if (this.user && this.user.displayName === q) {
        return
      }
      
      if (!q) {
        this.cancelGetUsers()
        this.clear()
        return
      }

      if (this.confidentialOptionsComputed.authorizedPeople) {
        this.users = this.confidentialOptionsComputed.authorizedPeople
          .filter((user) => q && q.trim() && user.displayName.toLowerCase().startsWith(q.toLowerCase()))
          .map((user) => ({ ...user }))
        return
      }

      if (q != null) {
        this.getUsers(q)
      }
    }, 10),

    user: debounce(function (u) {
      this.trigger = 'add'
      if (u !== undefined && u !== null) {
        this.showIcon = true
        if ((this.selectedUsers || []).length === 0) {
          this.selectedUsers = []
        }
        this.selectedUsers.push(u)
        const tempUsers = this.$_.clone(this.selectedUsers)
        const uniqueUsers = this.$_.uniqBy(tempUsers, 'id')
        this.selectedUsers = this.$_.sortBy(uniqueUsers, 'displayName')

        this.users = []
        this.$emit('update:model-value', this.selectedUsers)
        this.user = null
        this.userSearch = ''
      } else {
        this.users = []
      }
    }, 100)
  },
  components: {
    UserDetails,
    AddBulkUsers
  },
  computed: {
    displayUsers() {
      return this.$_.sortBy(this.users, [
        (user) => {
          if (user.displayName) {
            user.displayName.toLowerCase()
          }
        }
      ])
    },
    displaySelectedUsers() {
      return this.$_.sortBy(this.selectedUsers, [
        (user) => {
          if (user.displayName) {
            user.displayName.toLowerCase()
          }
        }
      ])
    },
    bgColor() {
      return this.color ? this.color : null
    },
    displayTitle: function () {
      return this.showCounter ? `${this.title} (${(this.selectedUsers || []).length})` : this.title
    },
    confidentialOptionsComputed() {
      const injectedConfidentialOptionsProperties = this.getPeoplePickerInjectedProperties().confidentialOptions
      return this.confidentialOptions || injectedConfidentialOptionsProperties || {}
    },
    isAddExternalDisabled() {
      return !this.externalEmailRules.map((r) => r(this.externalUser)).every((r) => r === true)
    }
  },
  inject: {
    getPeoplePickerInjectedProperties: {
      default: () => {
        return () => ({ confidentialOptions: undefined })
      }
    }
  }
}
</script>

<style scoped>
.job-title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 170px;
}

.centered-checkbox {
  display: flex;
  align-items: center;
}
</style>
<style>
.cbox-approver > div.v-input__details{
  display: none;
}
.v-toolbar-title {
  font-size: .95rem;
}
.v-checkbox .v-selection-control {
  min-height: auto;
}
</style>
